"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRouterDom = require("react-router-dom");

var useQuery = function useQuery() {
  var location = (0, _reactRouterDom.useLocation)();
  var search = location.search;
  if (!search) return {};
  var params = search.slice(1);
  return params.split('&').reduce(function (result, param) {
    var values = param.split('=');
    result[values[0]] = values[1];
    return result;
  }, {});
};

var _default = useQuery;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/hooks/useQuery.js
// module id = 254
// module chunks = 0